import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '@providers/api/api';

@Injectable()
export class NotesProvider {
  
    constructor(public api: Api) { }

    inactive(params?:any){
        let seq = this.api.post('index.php/myradiant/Notes/inactive', params);
        return seq;  
    }

    addNotes(params?:any){
        let seq = this.api.post('index.php/myradiant/Notes/add', params);
        return seq;  
    }

    editNotes(params?:any){
        let seq = this.api.post('index.php/myradiant/Notes/edit', params);
        return seq;  
    }
}



// WEBPACK FOOTER //
// ./src/providers/myradiant/notes/provider.ts